import axios from 'axios'

export function rbacAuthHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
    'Content-Type': 'application/json'
  }
}

export async function listRoles(params = {}) {
  const { data } = await axios.post(
    '/api/v1/role/list',
    { page: 1, pageSize: 200, ...params },
    { headers: rbacAuthHeaders() }
  )
  return data
}

export async function listPermissions(params = {}) {
  const { data } = await axios.post(
    '/api/v1/permission/list',
    { page: 1, pageSize: 500, ...params },
    { headers: rbacAuthHeaders() }
  )
  return data
}

export async function getRole(id) {
  const { data } = await axios.post('/api/v1/role/read', { id }, { headers: rbacAuthHeaders() })
  return data
}

export async function createRole(payload) {
  const { data } = await axios.post('/api/v1/role/create', payload, { headers: rbacAuthHeaders() })
  return data
}

export async function updateRole(payload) {
  const { data } = await axios.post('/api/v1/role/update', payload, { headers: rbacAuthHeaders() })
  return data
}

export async function deleteRole(id) {
  const { data } = await axios.post('/api/v1/role/delete', { id }, { headers: rbacAuthHeaders() })
  return data
}

/** 解析并校验 userUuid（可传 uuid 字符串或带 uuid 字段的用户对象） */
export function requireUserUuid(userOrUuid) {
  const userUuid =
    typeof userOrUuid === 'string'
      ? userOrUuid.trim()
      : String(userOrUuid?.uuid || userOrUuid?.userUuid || '').trim()
  if (!userUuid) {
    throw new Error('缺少 userUuid，无法操作 RBAC 角色')
  }
  return userUuid
}

export async function getUserRoles(userUuid) {
  const { data } = await axios.post(
    '/api/v1/user/roles',
    { userUuid: requireUserUuid(userUuid) },
    { headers: rbacAuthHeaders() }
  )
  return data
}

export async function assignUserRole(userUuid, roleId) {
  const { data } = await axios.post(
    '/api/v1/user/role/assign',
    { userUuid: requireUserUuid(userUuid), roleId },
    { headers: rbacAuthHeaders() }
  )
  return data
}

export async function revokeUserRole(userUuid, roleId) {
  const { data } = await axios.post(
    '/api/v1/user/role/revoke',
    { userUuid: requireUserUuid(userUuid), roleId },
    { headers: rbacAuthHeaders() }
  )
  return data
}

export async function createPermission(payload) {
  const { data } = await axios.post('/api/v1/permission/create', payload, { headers: rbacAuthHeaders() })
  return data
}

export async function updatePermission(payload) {
  const { data } = await axios.post('/api/v1/permission/update', payload, { headers: rbacAuthHeaders() })
  return data
}

export async function deletePermission(id) {
  const { data } = await axios.post('/api/v1/permission/delete', { id }, { headers: rbacAuthHeaders() })
  return data
}
